import { Injectable } from '@angular/core';
import * as queries from '@app/core/graphql/queries';
import {
    CreateProviderSettingInput,
    ProviderSetting,
    UpdateProviderSettingInput
} from '@app/core/services/api/API.service';

import { generateClient } from '@aws-amplify/api';
import * as mutations from '@graphql/mutations';

@Injectable({
    providedIn: 'root'
})
export class ProviderSettingService {
    private amplifyClient = generateClient();

    async listProvidersSetting(): Promise<ProviderSetting[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listProviderSettings,
                    variables: {
                        limit: 1000
                    }
                })
            ).data.listProviderSettings;
            return data.items as ProviderSetting[];
        } catch (error) {
            console.error('Error finding ProviderSetting', error);
            return [];
        }
    }

    async getProviderSetting(id: string): Promise<ProviderSetting> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.getProviderSetting,
                    variables: { id }
                })
            ).data.getProviderSetting;
            if (data) return data as ProviderSetting;
        } catch (error) {
            console.error('Error finding ProviderSetting', error);
            return null;
        }
    }

    async createProviderSetting(
        input: CreateProviderSettingInput
    ): Promise<ProviderSetting> {
        try {
            const provider = (
                await this.amplifyClient.graphql({
                    query: mutations.createProviderSetting,
                    variables: {
                        input
                    }
                })
            ).data.createProviderSetting;
            if (provider) return provider as ProviderSetting;
        } catch (error) {
            console.error('Error creating providerSetting', error);
            return null;
        }
    }
    async updateProviderSetting(
        input: UpdateProviderSettingInput
    ): Promise<ProviderSetting> {
        try {
            const provider = (
                await this.amplifyClient.graphql({
                    query: mutations.updateProviderSetting,
                    variables: {
                        input
                    }
                })
            ).data.updateProviderSetting;
            if (provider) return provider as ProviderSetting;
        } catch (error) {
            console.error('Error updating providerSetting', error);
            return null;
        }
    }
}
